import React from "react";
import { Table } from "antd";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";

const EducationStaffSummary = ({ config }) => {

  /* ---------- SAMPLE DATA ---------- */

  const summary = {
    entry: 54,
    exit: 49,
    inside: 5
  };

  const workingHours = [
    { name: "John", hours: 8 },
    { name: "Ravi", hours: 7 },
    { name: "Meena", hours: 9 }
  ];

  const attendanceTrend = [
    { day: "Mon", value: 45 },
    { day: "Tue", value: 52 },
    { day: "Wed", value: 50 },
    { day: "Thu", value: 48 },
    { day: "Fri", value: 54 }
  ];

  const mostActive = [
    { name: "Meena", hours: 9 },
    { name: "John", hours: 8 }
  ];

  const leastActive = [
    { name: "Ravi", hours: 5 },
    { name: "Ajay", hours: 4 }
  ];

  /* ---------- COMMON COMPONENTS ---------- */

  const MetricCard = ({ title, value }) => (

    <div className="bg-white p-6 rounded-xl shadow">

      <h4 className="text-gray-500 text-sm">{title}</h4>

      <p className="text-3xl font-bold">{value}</p>

    </div>

  );

  const TrendGraph = ({ title, data }) => {

    if (!data?.length) {

      return (
        <div className="bg-white p-6 rounded-xl shadow text-center text-gray-400">
          No Data Available
        </div>
      );

    }

    return (

      <div className="bg-white p-6 rounded-xl shadow">

        <h3 className="font-semibold mb-4">{title}</h3>

        <ResponsiveContainer width="100%" height={250}>

          <AreaChart data={data}>

            <CartesianGrid strokeDasharray="3 3" />

            <XAxis dataKey="day" />

            <YAxis />

            <Tooltip />

            <Area
              type="monotone"
              dataKey="value"
              stroke="#6366f1"
              fill="#c7d2fe"
            />

          </AreaChart>

        </ResponsiveContainer>

      </div>

    );

  };

  const SimpleTable = ({ title, data }) => {

    if (!data?.length) {

      return (
        <div className="bg-white p-6 rounded-xl shadow text-center text-gray-400">
          No Data Available
        </div>
      );

    }

    const columns = [
      { title: "Staff", dataIndex: "name" },
      { title: "Hours", dataIndex: "hours" }
    ];

    return (

      <div className="bg-white p-6 rounded-xl shadow">

        <h3 className="font-semibold mb-4">{title}</h3>

        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          size="small"
        />

      </div>

    );

  };

  /* ---------- WIDGET REGISTRY ---------- */

  const WIDGETS = {

    "Staff Entry Exit Summary": () => (

      <div className="grid grid-cols-3 gap-4">

        <MetricCard title="Entries" value={summary.entry} />

        <MetricCard title="Exits" value={summary.exit} />

        <MetricCard title="Inside Campus" value={summary.inside} />

      </div>

    ),

    "Staff Working Hours": () =>
      <SimpleTable title="Staff Working Hours" data={workingHours} />,

    "Most Active Staff": () =>
      <SimpleTable title="Most Active Staff" data={mostActive} />,

    "Least Active Staff": () =>
      <SimpleTable title="Least Active Staff" data={leastActive} />,

    "Staff Attendance Trend": () =>
      <TrendGraph title="Staff Attendance Trend" data={attendanceTrend} />

  };

  /* ---------- RENDER ---------- */

  return (

    <div>

      {config?.rows?.map((row, idx) => (

        <div
          key={idx}
          className={`grid grid-cols-${row.cards.length} gap-6 mb-6`}
        >

          {row.cards.map((card, i) => {

            const Widget = WIDGETS[card.name];

            if (!Widget) return null;

            return (
              <div key={i}>
                <Widget />
              </div>
            );

          })}

        </div>

      ))}

    </div>

  );

};

export default EducationStaffSummary;